import { FC, HTMLAttributes, ReactNode } from 'react';

import { Button, Flex, theme, Typography } from 'antd';
import { BaseButtonProps } from 'antd/es/button/button';
import cn from 'classnames';

import { useMedia } from 'shared/hooks';
import { CopyButton } from 'shared/ui';

import styles from './ProfileItem.module.scss';

interface IProfileItemProps extends HTMLAttributes<HTMLDivElement> {
	label: ReactNode;
	value?: string;
	link?: string;
	buttonText?: string;
	buttonIcon?: ReactNode;
	buttonColor?: BaseButtonProps['color'];
	action?: () => void;
	isDownload?: boolean;
	withCopy?: boolean;
	isLoading?: boolean;
}

export const ProfileItem: FC<IProfileItemProps> = ({
	className,
	label,
	value,
	link,
	buttonText,
	buttonIcon,
	buttonColor = 'primary',
	isDownload,
	action,
	withCopy,
	isLoading,
	...props
}) => {
	const {
		token: { colorBorderSecondary },
	} = theme.useToken();
	const isMd = useMedia();

	return (
		<Flex
			{...props}
			align="center"
			gap={24}
			className={cn(className, styles.item)}
			style={{ borderColor: colorBorderSecondary }}>
			<Flex className={styles.value}>
				<Typography.Text style={{ fontSize: isMd ? 14 : 16 }} type="secondary" className={styles.label}>
					{label}
				</Typography.Text>
				<Flex align="center" style={{ width: withCopy ? 200 : undefined }}>
					<Typography.Text style={{ fontSize: 16 }} ellipsis={withCopy ? { tooltip: value } : undefined}>
						{value}
					</Typography.Text>
					{withCopy && (
						<CopyButton
							text={value || ''}
							size="small"
							variant="text"
							color="primary"
							style={{ width: 24, height: 24, minWidth: 24 }}
						/>
					)}
				</Flex>
			</Flex>

			<Flex justify="end" style={{ width: isMd ? 'auto' : 140 }}>
				{buttonText ? (
					<Button
						variant="text"
						color={buttonColor}
						icon={isMd ? buttonIcon : undefined}
						href={link}
						download={isDownload}
						onClick={action}
						loading={isLoading}
						disabled={isLoading}>
						{(!isMd || !buttonIcon) && buttonText}
					</Button>
				) : (
					' '
				)}
			</Flex>
		</Flex>
	);
};
